var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailPaymentsSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 97,
    viewBox: "0 0 109 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 0.125H102.875C104.301 0.125 105.668 0.691293 106.676 1.6993C107.684 2.70731 108.25 4.07446 108.25 5.5V91.5C108.25 92.9255 107.684 94.2927 106.676 95.3007C105.668 96.3087 104.301 96.875 102.875 96.875H6.125C4.69946 96.875 3.33231 96.3087 2.3243 95.3007C1.31629 94.2927 0.75 92.9255 0.75 91.5V5.5C0.75 4.07446 1.31629 2.70731 2.3243 1.6993C3.33231 0.691293 4.69946 0.125 6.125 0.125ZM54.8225 46.7961L20.358 17.5292L13.3974 25.7208L54.8924 60.9539L95.6402 25.6939L88.6098 17.5615L54.8279 46.7961H54.8225Z",
    fill: "#023A5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailPaymentsSocial);
export default __webpack_public_path__ + "static/media/GmailPaymentsSocial.c7b55ca645cc6db9107118c6c28f1779.svg";
export { ForwardRef as ReactComponent };